// extracted by mini-css-extract-plugin
export default {"content":"Vla-z","title":"Wla-z","subTitle":"Xla-z","banner":"Yla-z","productCardOverride":"Zla-z"};